// extracted by mini-css-extract-plugin
export default {"storePage":"StorePage_storePage__zPHDn","mainArea":"StorePage_mainArea__fenKl"};